<template>
  <div class="page">
    <el-card>
      <div slot="header" class="clearfix">
        <span>金属单价管理</span>
        <div style="float:right;">
          <el-input
            v-model="keyword"
            placeholder="按金属名称搜索"
            size="mini"
            clearable
            style="width: 180px; margin-right: 10px;"
            @keyup.enter.native="getList"
          />
          <el-button type="primary" size="mini" @click="getList">查询</el-button>
          <el-button size="mini" @click="resetSearch">重置</el-button>
          <el-button
            type="success"
            size="mini"
            style="margin-left: 10px;"
            @click="openAdd"
          >
            新增金属
          </el-button>
        </div>
      </div>

      <!-- 表格 -->
      <el-table
        :data="list"
        border
        stripe
        style="width:100%"
        v-loading="loading"
      >
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="metal_name" label="金属名称" />
        <el-table-column
          prop="price_per_kg"
          label="单价(元/kg)"
          width="140"
        />
        <el-table-column
          prop="create_time_text"
          label="创建时间"
          width="180"
        />
        <el-table-column
          prop="update_time_text"
          label="更新时间"
          width="180"
        />

        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="openEdit(row)">
              编辑
            </el-button>
            <el-button type="danger" size="mini" @click="remove(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-box">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50]"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 新增 / 编辑弹窗 -->
    <el-dialog
      :title="form.id ? '编辑金属单价' : '新增金属单价'"
      :visible.sync="dialogVisible"
      width="400px"
    >
      <el-form :model="form" label-width="90px">
        <el-form-item label="金属名称">
          <el-input v-model="form.metal_name" placeholder="例如：废铜" />
        </el-form-item>
        <el-form-item label="单价(元/kg)">
          <el-input
            v-model.number="form.price_per_kg"
            type="number"
            placeholder="例如：12.5"
          />
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

const BASE_URL = "https://wx.hzxcet.com"; // 按你接口文档来的域名

export default {
  name: "MetalManage",
  data() {
    return {
      list: [],
      loading: false,
      dialogVisible: false,
      form: {
        id: null,
        metal_name: "",
        price_per_kg: null
      },
      keyword: "",
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 列表
    async getList() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/api/metal_price/list`, {
          params: {
            page: this.currentPage,
            page_size: this.pageSize,
            keyword: this.keyword || ""
          }
        });
        const data = res.data;
        if (data.code === 0) {
          this.list = data.data || [];
          this.total = data.total || 0;
          this.currentPage = data.page || this.currentPage;
          this.pageSize = data.page_size || this.pageSize;
        } else {
          this.$message.error(data.msg || "获取列表失败");
        }
      } catch (e) {
        console.error(e);
        this.$message.error("获取列表失败");
      } finally {
        this.loading = false;
      }
    },

    resetSearch() {
      this.keyword = "";
      this.currentPage = 1;
      this.getList();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    // 新增
    openAdd() {
      this.form = {
        id: null,
        metal_name: "",
        price_per_kg: null
      };
      this.dialogVisible = true;
    },

    // 编辑
    openEdit(row) {
      this.form = {
        id: row.id,
        metal_name: row.metal_name,
        price_per_kg: row.price_per_kg
      };
      this.dialogVisible = true;
    },

    // 保存（新增 / 编辑）
    async save() {
      if (!this.form.metal_name) {
        this.$message.error("请输入金属名称");
        return;
      }
      if (this.form.price_per_kg === null || this.form.price_per_kg === "") {
        this.$message.error("请输入单价");
        return;
      }

      try {
        let url = "";
        const body = {
          metal_name: this.form.metal_name,
          price_per_kg: this.form.price_per_kg
        };

        // 有 id = 编辑；没 id = 新增
        if (this.form.id) {
          url = `${BASE_URL}/api/metal_price/update`;
          body.id = this.form.id;
        } else {
          url = `${BASE_URL}/api/metal_price/create`;
        }

        const res = await axios.post(url, body, {
          headers: {
            "Content-Type": "application/json"
          }
        });

        const data = res.data;
        if (data.code === 0) {
          this.$message.success(this.form.id ? "修改成功" : "新增成功");
          this.dialogVisible = false;
          this.getList();
        } else {
          this.$message.error(data.msg || "保存失败");
        }
      } catch (e) {
        console.error(e);
        this.$message.error("保存失败");
      }
    },

    // 删除
    async remove(row) {
      try {
        await this.$confirm(
          `确认删除【${row.metal_name}】这条金属单价吗？`,
          "提示",
          { type: "warning" }
        );
      } catch (e) {
        return;
      }

      try {
        const res = await axios.post(
          `${BASE_URL}/api/metal_price/delete`,
          { id: row.id },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );
        const data = res.data;
        if (data.code === 0) {
          this.$message.success("删除成功");
          this.getList();
        } else {
          this.$message.error(data.msg || "删除失败");
        }
      } catch (e) {
        console.error(e);
        this.$message.error("删除失败");
      }
    }
  }
};
</script>

<style scoped>
.page {
  padding: 10px;
}
.pagination-box {
  margin-top: 20px;
  text-align: right;
}
</style>
